export enum SCROLL_DIRECTION {
  TOP_DETECTION = "top",
  BOTTOM_DETECTION = "bottom",
}
